// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2f9GF","label":"CategoryService_label__1mumf","location":"CategoryService_location__218lu"};